import { InjectionToken } from '@angular/core';
import { TabsetDirective } from '../directives/tabset.directive';

export type TabsetDirectiveType = TabsetDirective;

export const TabsetDirectiveToken = new InjectionToken<TabsetDirectiveType>('TabsetDirectiveToken');
